import { ReactNode, forwardRef } from 'react';
import { useMotionReveal } from '../../hooks/useMotion';

interface MotionWrapperProps {
  children: ReactNode;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
  delay?: number;
}

const MotionWrapper = forwardRef<HTMLElement, MotionWrapperProps>(
  ({ children, className = '', as: Component = 'div', delay = 0 }, ref) => {
    const motionRef = useMotionReveal();
    
    const combinedRef = (element: HTMLElement | null) => {
      if (motionRef.current !== element) {
        // @ts-ignore
        motionRef.current = element;
      }
      if (typeof ref === 'function') {
        ref(element);
      } else if (ref) {
        ref.current = element;
      }
    };

    const motionClass = 'motion-section-reveal';
    const delayStyle = delay > 0 ? { transitionDelay: `${delay}ms` } : {};

    return (
      <Component
        ref={combinedRef}
        className={`${motionClass} ${className}`}
        style={delayStyle}
      >
        {children}
      </Component>
    );
  }
);

MotionWrapper.displayName = 'MotionWrapper';

export default MotionWrapper;